<template>
  <div class="home-boxes">
    <div class="grid-4">
      <div class="home-box">
        <div class="box_right">
          <div class="home-num">{{ recent_buildings }}</div>
          <div class="home-title">{{ $t('homeBoxes.currentProperties') }}</div>
        </div>
        <div class="box-left">
          <img :src="img1" alt="" />
        </div>
      </div>

      <div class="home-box">
        <div class="box_right">
          <div class="home-num">{{ management_orders }}</div>
          <div class="home-title">{{ $t('homeBoxes.newManagementOrders') }}</div>
        </div>
        <div class="box-left">
          <img :src="img2" alt="" />
        </div>
      </div>

      <div class="home-box">
        <div class="box_right">
          <div class="home-num">{{ all_buildings }}</div>
          <div class="home-title">{{ $t('homeBoxes.totalProperties') }}</div>
        </div>
        <div class="box-left">
          <img :src="img3" alt="" />
        </div>
      </div>

      <div class="home-box">
        <div class="box_right">
          <div class="home-num">{{ maintenance_orders }}</div>
          <div class="home-title">{{ $t('homeBoxes.totalMaintenanceOrders') }}</div>
        </div>
        <div class="box-left">
          <img :src="img4" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// imports
import { ref, onMounted, defineProps } from "vue";

// props
const props = defineProps([
  "recent_buildings",
  "maintenance_orders",
  "all_buildings",
  "management_orders",
]);

// reactive states
const img1 = ref(
  require("../../assets/imgs/344772042_1657766668005350_4842863702189116936_n.png")
);
const img2 = ref(
  require("../../assets/imgs/342233619_202711872623170_8213122266667585191_n.png")
);
const img3 = ref(
  require("../../assets/imgs/341963084_1340434330148672_850767821321410202_n.png")
);
const img4 = ref(
  require("../../assets/imgs/341960256_910153316903205_2431320066108902115_n.png")
);

// lifecycle hooks
onMounted(() => {
  console.log(props);
});
</script>
